import { createLogger } from 'logger-js'
import getHashValueLocationUtil from 'modules/router/utils/get-hash-value'
import queueMicrotaskPerfUtil from 'modules/performance/queue-microtask/index.js'
import scrollToElementDomUtil from 'client/utils/dom/scroll-to-element/index.js'
import highlightElementDomUtil from 'client/utils/dom/highlight-element/index.js'
import runAfterDelayPromisifiedPerformanceUtil from 'modules/performance/run-after-delay-promisified/index.js'

const logger = createLogger({
  label: 'scrollToAnchorAppUtil'
})

const GET_ELEMENT_MAX_RETRY_COUNT = 3

/**
 * The delay between each get element retry.
 * @private
 * @type {number}
 */
const DELAY_GET_ELEMENT = 1000

/**
 * Jumps to an element using the `hash` of the current location if possible.
 * @param {Object} props
 * @param {Object} props.location
 * @param {number} [props.numRetry]
 * @param {number} [props.shouldHighlight]
 * @param {number} [props.hasDelay]
 */
export default async function scrollToAnchorAppUtil (props) {
  const {
    location,
    numRetry = 0,
    shouldHighlight = true,
    hasDelay = true
  } = props

  if (hasDelay) {
    await runAfterDelayPromisifiedPerformanceUtil({
      delay: DELAY_GET_ELEMENT
    })
  }

  const hash = getHashValueLocationUtil(location)
  if (!hash) {
    return
  }

  const element = document.getElementById(hash)
  if (!element && numRetry < GET_ELEMENT_MAX_RETRY_COUNT) {
    logger.debug('[retry] element not found')
    props.numRetry += 1
    return scrollToAnchorAppUtil({
      ...props,
      location,
      numRetry
    })
  }

  if (!element) {
    logger.debug('[noop] element not found, retry')
    return
  }

  queueMicrotaskPerfUtil(() => {
    logger.debug('[done]')
    scrollToElementDomUtil(element)

    if (!shouldHighlight) {
      return
    }

    queueMicrotaskPerfUtil(() => {
      highlightElementDomUtil(element)
    })
  })
}
